import { render, staticRenderFns } from "./settingSvg.vue?vue&type=template&id=1aebfb44"
import script from "./settingSvg.vue?vue&type=script&lang=js"
export * from "./settingSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports